export const HOMES_BANNER_NON_FLASH_SLOT_COUNTS = [4, 12, 24] as const
export const HOMES_CROSS_SELL_PROPERTY_TYPES = ['homes_villas', 'apartments']

export function computeHomesCrossSellBannerPositions(
  offerIds: Array<string>,
  isFlash: (id: string) => boolean,
  isResolved: (id: string) => boolean,
): Array<number> {
  let nonFlashSeen = 0
  let slotIndex = 0
  const positions: Array<number> = []

  for (let i = 0; i < offerIds.length; i++) {
    if (!isResolved(offerIds[i])) break
    if (isFlash(offerIds[i])) continue

    nonFlashSeen += 1
    if (slotIndex < HOMES_BANNER_NON_FLASH_SLOT_COUNTS.length && nonFlashSeen === HOMES_BANNER_NON_FLASH_SLOT_COUNTS[slotIndex]) {
      positions.push(i + 1)
      slotIndex += 1
    }
  }

  return positions
}

export function getHomesCrossSellBannerVariant(availableFilters: App.OfferListAvailableFilters | undefined): 'urban' | 'leisure' | undefined {
  const homes = availableFilters?.propertyTypes.find(item => item.slug === 'homes_villas')?.count ?? 0
  const apartments = availableFilters?.propertyTypes.find(item => item.slug === 'apartments')?.count ?? 0

  if (homes === 0 && apartments === 0) {
    return undefined
  }

  return apartments >= homes ? 'urban' : 'leisure'
}
